<template>
  <section>
    <p class="text-info mb-0 font-weight-bold"><i class="fas fa-hand-pointer mr-2"></i>Drag images to reorder</p>
    <draggable 
      v-if="images.length"
      :list="images"
      cancel="input"
      item-key="id"
      class="row"
      filter="input"
      :delay="30"
      @change="handleChange"
    >
      <template #item="{element}">
        <div class="col-md-3 my-2 draggable-item">
          <div class="product-image-container flex-center rounded">
            <a 
              v-if="element.url.indexOf('pdf') != -1"
              :href="element.url"
              target="_blank"
              title="View PDF"
              class="text-secondary view-pdf"
            >
              <i class="fas fa-file-pdf mr-2 fa-lg"></i> {{ element.source_desc }}
            </a>
            <template v-else>
              <img class="rounded" :src="element.url" />
            </template>
          </div>
          <div class="mt-2 d-flex justify-content-between">
            <div>
              <i @click="makePrimary(element.id)" class="fa-lg text-primary cursor-pointer mr-3"
              :class="[element.is_main ? 'fas fa-star' : 'far fa-star']"
              :title="[element.is_main ? 'Don\'t make this image primary' : 'Make this image primary']"></i>
              <i @click="deleteImage(element.id)" class="fa fa-trash text-secondary cursor-pointer" title="Remove Image"></i>
            </div>
            <span v-if="element.is_main" class="badge badge-primary d-flex align-items-center">Primary</span>
          </div>
          <div>
            <input 
              v-if="image_type == 3"
              type="text"
              class="form-control form-control-sm mt-2"
              placeholder="Enter caption..."
              :value="element.caption_plain_text"
              @click="e => e.target.focus()"
              @change="e => updateCaption(element.id, e)"
            />
          </div>
        </div>
      </template>
      
    </draggable>
  </section>
</template>

<script>
  import draggable from 'vuedraggable'

  export default {
    data() {
      return {
        imageForm: this.$inertia.form({
          _method: 'put',
          image_id: null,
          type: this.image_type,
          caption_plain_text: null
        }),
      }
    },
    components: {
      draggable
    },
    props: {
      images: Array,
      product: Object,
      image_type: Number
    },
    methods: {
      orderImages() {
        this.images.forEach( (image, index) => image.sort_order = index )
      },
      handleChange() {
        this.orderImages()// Save order
        const orderRoute = this.isMtd() ? 'mtd.products.saveimageorder' : 'products.saveimageorder'
        this.$inertia.post(route(orderRoute, this.product.id), 
        {
          images: JSON.stringify(this.images)
        }, 
        {
          preserveScroll: true
        })
      },
      makePrimary(imageId) {
        const route = this.isMtd() ? 'mtd.products.makeImagePrimary' : 'products.makeImagePrimary'

        this.imageForm.image_id = imageId;
        this.imageForm.post(this.route(route, this.product.id), {
          preserveScroll: true
        })
      },
      deleteImage(imageId) {
        const route = this.isMtd() ? 'mtd.products.deleteImage' : 'products.deleteImage'

        this.imageForm.image_id = imageId;
        this.imageForm.post(this.route(route, this.product.id), {
          preserveScroll: true
        })
      },
      updateCaption(imageId, e) {
        const route = this.isMtd() ? 'mtd.products.images.update' : 'products.images.update'

        this.imageForm.caption_plain_text = e.target.value;
        this.imageForm.post(this.route(route, imageId), {
          preserveScroll: true
        })        
      }
    }
  }
</script>

<style scoped>
  .product-image-container {
    height: 200px;
  }

  .product-image-container img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }

  .draggable-item {
    cursor: pointer;
    transition: all 0.25s ease;
    transform: translateY(0);
  }

  .draggable-item:hover {
    transform: translateY(-1.5px);
  }
</style>
